import React, { useCallback, useContext } from 'react';
import cx from 'classnames';
import { camelCase } from 'lodash';

import cypressIds from 'Components/cypress_ids.json';
import { ShortlistButton } from 'Components/shared/ShortlistButton/ShortlistButton';
import { VehicleContext } from 'Context/VehicleContext';
import { useShortlistStore } from 'Stores/ShortlistStore/ShortlistStore';
import { applyCypressData, applyTestData } from 'Utilities/helpers';
import proPropTypes from 'Utilities/proPropTypes';

import styles from './VehicleListShortlistButton.module.scss';

const VehicleCardShortlistButton = ({ onClickShortlist, page, shortlistButtonClassName }) => {
	const { id } = useContext(VehicleContext);
	const isShortlisted = useShortlistStore(useCallback((store) => !!store.shortlist[id], [id]));

	return (
		<div
			className={styles.vehicleListShortlistButtonContainer}
			{...applyCypressData(cypressIds.containers.vehicleListShortlistButton)}
			{...applyTestData({ 'vehicle-id': id })}
		>
			<ShortlistButton
				rounded
				className={cx(styles.vehicleListShortlistButton, shortlistButtonClassName, 'vehicleCardOnFocus', {
					[styles.selected]: isShortlisted,
				})}
				id={id}
				inputProps={{ ...applyCypressData(camelCase(`$ ${cypressIds.buttons.vehicleCard.shortList}`)) }}
				onClickShortlist={onClickShortlist}
				page={page}
			/>
		</div>
	);
};

VehicleCardShortlistButton.propTypes = {
	shortlistButtonClassName: proPropTypes.className.isRequired,
};

export default VehicleCardShortlistButton;
